<template>
  <div class="head-skeleton">
    <div class="skeleton-item" style="width: 20%; height: 30px; left: 480px; top: 10px;"></div>
    <div class="skeleton-item" style="width: 100%; height: 0px; left: 0px; top: 50px; border-bottom: solid 1px #EBEBEB;"></div>
    <div class="skeleton-item" style="width: 10%; height: 30px; left: 10px; top: 60px;"></div>
    <div class="skeleton-item" style="width: 10%; height: 30px; left: 140px; top: 60px;"></div>
    <div class="skeleton-item" style="width: 10%; height: 30px; left: 270px; top: 60px;"></div>
    <div class="skeleton-item" style="width: 10%; height: 30px; left: 400px; top: 60px;"></div>
    <div class="skeleton-item" style="width: 100%; height: 0px; left: 0px; top: 100px; border-bottom: solid 1px #EBEBEB;"></div>
    <div class="skeleton-item" style="width: 90%; height: 650px; left: 50px; top: 110px;"></div>
  </div>
</template>

<script>
export default {
  name: 'VueHeaderLoading',
  data() {
    return {

    }
  }
}
</script>

<style lang="scss">
  @keyframes headerAnimation {
    50% {
      opacity: 0.6;
    }
  }
  @keyframes height1 {
    25% {
        width: 98%;
        top: 110px;
    }
    37% {
        width: 0;
        top: 230px;
    }
    62% {
      width: 98%;
      top: 230px;
    }
    74% {
      width: 0;
      top: 110px;
    }
  }
  @keyframes height2 {
    25% {
        width: 98%;
        top: 330px;
    }
    37% {
        width: 0;
        top: 110px;
    }
    62% {
      width: 98%;
      top: 110px;
    }
    74% {
      width: 0;
      top: 330px;
    }
  }
  @keyframes height3 {
    25% {
      width: 98%;
      top: 450px;
    }
    37% {
      width: 0;
      top: 450px;
    }
    62% {
      width: 98%;
      top: 450px;
    }
    74% {
      width: 0;
      top: 450px;
    }
  }

  .head-skeleton {
    position: relative;
    height: 800px;
    width: 100%;

    & .skeleton-item {
      position: absolute;
      background-color: #d3d3d3;
      opacity: 1;
      animation: headerAnimation 1.2s ease-in-out infinite;
      transform: none;
      border-radius: 4px;
      &--1 {
        animation: height1 8s ease-in-out infinite;
        width: 98%;
        height: 200px;
        left: 10px;
        top: 110px;
      }
      &--2 {
        animation: height2 8s ease-in-out infinite;
        width: 98%;
        height: 100px;
        left: 10px;
        top: 330px;
      }
      &--3 {
        animation: height3 8s ease-in-out infinite;
        width: 98%;
        height: 300px;
        left: 10px;
        top: 450px;
      }
    }
  }
</style>
